var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"region","aria-label":"Skip to content"}},[_c('a',{staticClass:"skip-to-content",attrs:{"href":"#main-content"}},[_vm._v(_vm._s(this.$pgettext('Skip to content', 'Passa a contenuti principali')))])])}
var staticRenderFns = []

export { render, staticRenderFns }